<template>
  <div id="app" :class="`${isMobile?'mobile':'pc'} ${activeMenu}`">
    <!--    <iframe class="inter-iframe iframe" v-if="activeMenu==='inter'" :src="interIframeUrl"></iframe>-->
    <inter-iframe class="inter-iframe iframe" v-if="activeMenu==='inter'" :inter-position="interPosition"/>
    <iframe class="outer-iframe iframe" :class="{outerLoaded:outerLoaded,interShowing:activeMenu!=='outer'}" id="iframe_360"
            :src="outerIframeUrl"></iframe>

    <div v-show="outerLoaded">
      <transition name="fade">
        <div class="interLoaded" v-show="!interLoaded" @click="interLoaded=!interLoaded"></div>
      </transition>
      <div class="note">
        *所示图片，颜色仅供参考，请以实车为准。具体零售交易价格、产品式样、配置及交易细节请与当地世极授权经销商协商确定。
      </div>
      <div class="icon-360" :class="{bot:!hideSpan}"></div>
      <div class="top-back" v-if="!isMobile"></div>
      <div class="menu-list">
        <div class="menu-content">
          <div class="menu outer-menu" :class="{active:activeMenu==='outer'}" @click="activeMenu='outer'">
            外观
          </div>
          <div class="line"></div>
          <div class="menu inter-menu" :class="{active:activeMenu==='inter'}" @click="goInter">
            内室
          </div>
        </div>
      </div>
      <outer-tool class="outer-tool tool-box" v-show="activeMenu==='outer'"
                  :activeColor="activeColor"
                  @hideSpan="setHideSpan"
                  @setShowMobileColor="setShowMobileColor"></outer-tool>
      <inter-tool class="inter-tool tool-box" v-show="activeMenu==='inter'&&isMobile"
                  :activeInterColor="activeInterColor"
                  @selectInterPos="selectInterPos"
                  @setShowMobileColor="setShowMobileColor"></inter-tool>
      <div v-show="!isMobile||showMobileColor">
        <div class="outer-color-list color-list" v-if="activeMenu==='outer'">
          <div class="scroll">
            <div class="color-item" @click="setColor(item.value)" v-for="item in carConfig.car.value" :key="item.value"
                 :class="{active:activeColor===item.value}">
              <div class="dot-box">
                <div class="dot" :class="item.value">
                  <img :src="require(`img/${item.value}.png`)">
                  <!--                  <p class="hel" v-for="col in item.color" :key="col" :style="{background:col}"></p>-->
                </div>
              </div>
              <p class="color-name">
                {{ item.label }}
              </p>
              <div class="line"></div>
            </div>
          </div>
        </div>
        <div class="color-list inter-color-list" v-else>
          <div class="color-item" v-for="item in interColorList" :key="item.value"
               :class="{active:activeInterColor===item.value}" @click="selectInterColor(item.value)">
            <div class="dot-box">
              <div class="dot" :class="item.value">
                <img :src="require(`img/${item.value}.png`)">
                <!--                <p class="hel" v-for="col in item.color" :key="col" :style="{background:col}"></p>-->
              </div>
            </div>

            <p class="color-name">
              {{ item.label }}
            </p>
            <div class="line"></div>
          </div>
          <div class="pos-group" v-if="!isMobile">
            <div class="pos-tos-icon"></div>
            <div class="pos-tos-name">选择<br/>视角</div>
            <div class="pos-item" v-for="pos in interPosList" :key="pos.value" @click="selectInterPos(pos.value)"
                 :class="[{active:pos.value===activeInterPos}]">
              <div class="pos-icon" :class="pos.value"></div>
              <div class="pos-name">{{ pos.label }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {isMobile} from "@/utils";
import {carConfig, iframeBaseUrl, interColorTar, interPositionTar} from "@/config";
import outerTool from './views/outer-tool.vue'
import interTool from './views/inter-tool.vue'
import app from "@/utils/app";
import InterIframe from "@/views/inter-iframe.vue";

export default {
  components: {
    InterIframe,
    outerTool,
    interTool
  },
  data() {
    return {
      outerIframeUrl: `${iframeBaseUrl}/outer/export.html`,
      outerLoaded: false,
      interLoaded: true,
      hideSpan: false,
      showMobileColor: false,
      interLoadedStyle: {},
      isMobile,
      carConfig,
      activeMenu: 'outer',
      activeColor: carConfig.defaultCar,
      activeInterColor: carConfig.defaultInter,
      activeInterPos: carConfig.inter[carConfig.defaultInter][0],
      interColorList: carConfig.interSort.map(color => ({
        ...interColorTar[color],
        value: color
      }))
    }
  },
  computed: {
    interPosList: vm => carConfig.inter[vm.activeInterColor].map(pos => ({
      label: interPositionTar[pos],
      value: pos
    })),
    interIframeUrl() {
      const activeInterColorTar = {
        'white': '',
        'black': '_black',
        40: 40,
        41: 41
      }
      const position = `${this.activeInterPos}${activeInterColorTar[this.activeInterColor]}`
      return `${iframeBaseUrl}/inter/index.html?inView=1&position=${position}`
    },
    interPosition() {
      const activeInterColorTar = {
        'white': '',
        'black': '_black',
        40: 40,
        41: 41
      }
      return `${this.activeInterPos}${activeInterColorTar[this.activeInterColor]}`
    }

  },
  methods: {
    setHideSpan(val) {
      console.log(val)
      this.hideSpan = val
    },
    setShowMobileColor(val) {
      this.showMobileColor = val
    },
    setColor(color) {
      this.activeColor = color
      app.changeOutConfig('car', color)
      if(color==='carC7'){
        app.changeOutConfig( 'changeDoor','backDoor1')
      }
    },
    goInter() {
      if (this.activeMenu !== 'inter') {
        this.interLoaded = false
        this.$nextTick(()=>{
          this.activeMenu = 'inter'
        })
        setTimeout(() => {
          this.interLoaded = true
        }, 1000)
      }
    },
    selectInterColor(value) {
      if (this.activeInterColor !== value) {
        this.$nextTick(() => {
          this.activeInterColor = value
          // this.activeInterPos = carConfig.inter[value][0]
        })
      }

    },
    selectInterPos(value) {
      if (this.activeInterPos !== value) {
        this.$nextTick(() => {
          this.activeInterPos = value
        })
      }
    }
  },
  created() {
    window.onV3dLoaded = () => {
      this.outerLoaded = true
    }
  }
}
</script>

<style lang="less">
@import './static/css/base.less';

#app {
  position: relative;
  //background: rgba(230, 230, 230);
  background: #fafafa;

  .interShowing.outer-iframe{
    width: 0 !important;
    height: 0 !important;
  }

  & * {
    box-sizing: border-box;
    transition: all 0.3s;
  }

  .inter-iframe * {
    transition: unset;
  }

  .note {
    pointer-events: none;
    position: absolute;
    bottom: 12px;
    text-align: center;
    color: #94a3b8;
    margin-left: 3px;
    height: max-content;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: 0.3s;
  }

  .fade-enter-to {
    opacity: 1;
  }

  .interLoaded {
    overflow: hidden;
    position: absolute;
    width: 100vw;
    height: 100vh;
    left: 0;
    top: 0;
    z-index: 10;
    background: rgba(0, 0, 0, 1);
  }

  .iframe {
    position: absolute;
    width: 100%;
    left: 0;
    top: 0;
    z-index: 1;
    border: 0;
    outline: 0;
    transition: unset;
  }


  .menu-list {
    z-index: 2;
    position: absolute;
    left: 0;
    //background: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0.02%, rgba(255, 255, 255, 0.61) 55.26%, rgba(255, 255, 255, 0.00) 101.03%);
    color: #A8A8A8;
    font-family: MHeiGB;
    font-style: normal;
    display: flex;
    align-items: center;
    justify-content: center;

    .menu-content {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .menu {
        position: relative;

        &.active {
          color: #000;
        }

        cursor: pointer;
      }

      .line {
        height: 75%;
        width: 2px;
        background: #fff;
      }
    }
  }

  &.pc {
    overflow: hidden;

    .note {
      bottom: 8rem;
      z-index: 1000;
      font-size: 10px;
    }

    .outerLoaded.outer-iframe {
      width: 90%;
      height: 100%;
    }

    .iframe {
      height: 100%;
    }


    .icon-360 {
      width: 120px;
      height: 44px;
      background-image: url("static/img/360.png");
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 7rem;
      z-index: 8;

    }

    .top-back {
      width: 100vw;
      height: 6.95187rem;
      position: absolute;
      z-index: 1;
      background: linear-gradient(180deg, rgba(0, 0, 0, 0.58) 1.36%, rgba(0, 0, 0, 0.00) 88.1%);
    }

    .menu-list {
      width: 18.47351rem;
      height: 2.91687rem;
      top: 1rem;
      left: 20px;
      font-size: 22px;
      font-weight: 900;

      .menu.active::after {
        content: "";
        display: block;
        width: 4.3753rem;
        height: 0.19446rem;
        background: #000;
        position: absolute;
        bottom: -0.4rem;
        left: 50%;
        transform: translateX(-50%);
      }

      .menu-content {
        width: 12.26495rem;
        height: 2.04181rem;
        color: #FFF;

        .menu {
          height: 2.04181rem;
          line-height: 2.04181rem;
          flex: 1;
          text-align: center;
        }
      }
    }

    .color-list {
      position: absolute;
      z-index: 4;
      left: 0;
      bottom: 0.44rem;
      width: 100%;
      height: 5.83374rem;
      padding-top: 0.73rem;
      padding-bottom: 0.73rem;
      display: flex;
      align-items: center;
      justify-content: center;

      &::-webkit-scrollbar {
        display: none
      }

      .scroll {
        display: flex;
        align-items: center;
        justify-content: center;

        &::-webkit-scrollbar {
          display: none
        }
      }

      .color-item {
        width: max-content;
        height: 4.3753rem;
        margin-right: 2.2rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        cursor: pointer;
        border-radius: 0.24307rem;

        &.active {
          background: #303030;
        }

        .dot-box {
          margin-top: 0.53rem;
          margin-bottom: 0.1rem;
        }

        .dot {
          width: 1.45843rem;
          height: 1.45843rem;
          border-radius: 50%;
          overflow: hidden;
          display: flex;
          border: 1px solid #ABA9A9;

          .hel {
            height: 100%;
            flex: 1;
          }
        }

        .color-name {
          width: max-content;
          padding: 0 0.97rem;
          text-align: center;
          color: #fff;
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          font-family: MHeiGB;
          font-size: 0.97229rem;
          font-style: normal;
          font-weight: 500;
        }
      }
    }

    .outer-color-list {
      background: linear-gradient(90deg, rgba(0, 0, 0, 0.00) 0.02%, rgba(58, 58, 58, 0.61) 55.26%, rgba(0, 0, 0, 0.00) 101.03%);

    }

    .inter-color-list {
      background: linear-gradient(90deg, rgba(0, 0, 0, 0.41) 0.02%, rgba(0, 0, 0, 0.68) 55.26%, rgba(0, 0, 0, 0.40) 101.03%);


      .pos-group {
        position: absolute;
        right: 0;
        top: 0;
        width: 20rem;
        height: 5.83374rem;
        display: flex;
        align-items: center;
        justify-content: flex-start;

        .pos-tos-icon {
          width: 2.6738rem;
          height: 2.6738rem;
          background-size: contain;
          background-image: url("static/img/pos.png");
        }

        .pos-tos-name {
          width: 4.67rem;
          padding-left: 0.44rem;
          display: flex;
          color: #FFF;

          font-family: MHeiGB;
          font-size: 1.16675rem;
          font-style: normal;
        }

        .pos-item {
          width: 3.88916rem;
          height: 4.3753rem;
          margin-right: 1.12rem;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: flex-start;
          cursor: pointer;
          border-radius: 0.24307rem;

          &.active {
            background: #303030;
          }

          .pos-icon {
            width: 1.94458rem;
            height: 1.94458rem;
            background-size: contain;
            margin-top: 0.53rem;

            &.main {
              background-image: url("static/img/main.png");
            }

            &.attached {
              background-image: url("static/img/attached.png");
            }

            &.backR {
              background-image: url("static/img/backR.png");
            }
          }

          .pos-name {
            text-align: center;
            color: #FFF;
            font-family: MHeiGB;
            height: 1.75783rem;
            line-height: 1.75783rem;
            font-size: 0.97229rem;
            font-style: normal;
            font-weight: 500;
          }
        }
      }

    }

    .outer-tool {
      height: max-content;
      position: absolute;
      z-index: 4;
      right: 3rem;
      top: 11.96rem;

      .card {
        width: 17.01507rem;
        border-radius: 0.48614rem;
        background: rgba(0, 0, 0, 0.7);
        padding-left: 1.12rem;
        padding-right: 1.46rem;

        .card-item {
          .card-item-top {
            display: flex;
            align-items: center;
            justify-content: center;

            .icon {
              width: 1.70151rem;
              height: 1.70151rem;
              margin-right: 0.97rem;
            }

            .label {
              color: #FFF;
              font-family: MHeiGB;
              font-size: 0.97229rem;
              font-style: normal;
              font-weight: 500;
              flex: 1;

              span {
                display: block;
                font-size: 0.67229rem;
                font-style: normal;
                font-weight: 300;
              }
            }

            .btn {
              width: 2.43072rem;
              height: 1.45843rem;
              display: flex;
              align-items: center;
              justify-content: center;
            }
          }
        }
      }

      .door {
        height: 3.40301rem;
        margin-bottom: 0.39rem;
        padding-left: 0;
        padding-right: 0;

        .card-item{
          .card-item-top {
            height: 3.40301rem;
            justify-content:unset;

            color: #FFF;

            font-size: 0.97229rem;
            font-style: normal;
            font-weight: 400;
            letter-spacing: -0.04035rem;

            .door-item{
              display: flex;
              align-items: center;

              &.active{
                .dd{
                  background: #fff;
                }
                .c-dd{
                  width: 0.21rem;
                  height: 0.21rem;
                  background: #393939;
                  border-radius: 50%;
                }
              }
            }
            .ping{
              margin-left: 0.34rem;
            }
            span{
              cursor: pointer;
            }
            .dd{
              width: 0.72713rem;
              height: 0.72713rem;
              margin: 0 0.8rem;
              border-radius: 50%;
              border: 2px solid #FFFFFF;
              display: flex;
              align-items: center;
              justify-content: center;
              cursor: pointer;
            }
          }
        }
      }

      .function {
        height: 3.40301rem;
        margin-bottom: 0.39rem;

        .card-item-top {
          height: 3.40301rem;

          .switch {
            width: 2.43072rem;
            height: 1.118rem;
            border-radius: 0.6rem;
            border: 1px solid #fff;
            transition: all 0.3s;
            position: relative;

            .dot {
              width: 0.918rem;
              height: 0.918rem;
              position: absolute;
              right: 0.1rem;
              top: 0.03rem;
              border-radius: 50%;
              background: #fff;
              transition: all 0.3s;
            }

            &.open {
              background: #fff;

              .dot {
                left: 0.1rem;
                right: unset;
                background: #2E2E2E;
              }
            }
          }
        }
      }

      .card-group {
        height: max-content;

        .card-item {
          border-bottom: 1px solid #B0B0B0;
        }

        .card-item-top {
          height: 3.89rem;
          cursor: pointer;

          .arrow {
            width: 1.45843rem;
            height: 1.45843rem;
            transition: all 0.3s;
            background-image: url("~img/arrow-down.png");
            background-size: contain;

            &.up {
              background-image: url("~img/arrow-up.png");
            }
          }
        }

        .card-item-content {
          width: 15rem;
          margin: 0.24rem auto 1.31rem;
          height: 6rem;
          display: flex;

          .card-content-item {
            width: 4.8rem;
            height: 5.77127rem;
            border-radius: 0.24307rem;
            display: flex;
            align-items: center;
            flex-direction: column;
            transition: all 0.3s;
            cursor: pointer;

            .cit-icon {
              width: 2.9rem;
              height: 2.9rem;
              margin-top: 0.8rem;
              margin-bottom: 0.8rem;
            }

            .cit-label {
              height: 0.67783rem;
              line-height: 0.67783rem;
              color: rgba(255, 255, 255, 0.60);
              text-align: center;
              font-family: MHeiGB;
              font-size: 0.76rem;
              font-style: normal;
              font-weight: 500;
              transition: all 0.3s;
            }

            &.active {
              background: #303030;

              .cit-label {
                color: #FFF;
              }
            }
          }
        }
      }
    }
  }

  &.mobile {
    .note {
      bottom: 31rem;
      z-index: 1000;
      font-size: 7px;
      right: 1rem;
      top: 3rem;
      width: 60vw;
      text-align: left;
    }

    .iframe {
      height: 100%;
    }

    .menu-list {
      width: 40rem;
      height: 10.25641rem;
      top: 1rem;
      font-size: 4.61538rem;
      background: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0.02%, rgba(255, 255, 255, 0.61) 55.26%, rgba(255, 255, 255, 0.00) 101.03%);

      .menu-content {
        width: 30rem;
        height: 5rem;

        .line {
          background: #A8A8A8;
        }
      }
    }

    .outer-tool {
      position: absolute;
      z-index: 4;
      bottom: 1.8rem;
      left: 0;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-direction: row-reverse;

      .card {
        height: 20.51282rem;
        border-radius: 1.28205rem;
        background: rgba(0, 0, 0, 0.70);
        padding: 1.54rem 4.35rem;

        .card-item {
          .card-item-top {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: 14.35897rem;
            height: 17.4359rem;
            border-radius: 1.28205rem;

            &.active {
              border-radius: 1.28205rem;
              background: #303030;
            }

            .icon {
              width: 7.69231rem;
              height: 7.69231rem;
              margin-bottom: 1.79rem;
            }

            .label {
              color: #FFF;
              text-align: center;
              font-family: MHeiGB;
              font-size: 3.58974rem;
              font-style: normal;
              font-weight: 500;

              &.hideSpan span {
                opacity: 0;
              }

              span {
                opacity: 1;
                width: 28rem;
                height: 9rem;
                background-image: url("static/img/union.png");
                background-repeat: no-repeat;
                background-size: contain;
                padding-top: 4px;
                top: -8rem;
                position: absolute;
                color: #FFF;
                font-family: MHeiGB;
                font-size: 3.07692rem;
                font-style: normal;
                font-weight: 500;
                letter-spacing: -0.83px;
              }
            }

            .btn {
              display: none;
            }
          }

          .card-item-content {
            height: 22rem;
            top: -24rem;
            width: max-content;
            border-radius: 1.28205rem;
            background: #fff;

            display: flex;
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            align-items: center;
            justify-content: center;


            .card-content-item {
              display: flex;
              flex-direction: column;
              align-items: center;
              width: 30.76923rem;
              height: 22rem;

              &:last-child {
                .line {
                  display: none;
                }
              }

              .line {
                height: 15.38462rem;
                width: 1px;
                background: #EAEAEA;
                position: absolute;
                right: 0px;
                top: 4.87rem;
                z-index: 4;
              }

              &.active {
                border-bottom: 1.02564rem solid #000;
              }

              .cit-icon-box {
                width: 10.25641rem;
                height: 10.25641rem;
                margin-top: 1.6rem;
              }

              .cit-icon {
                width: 10.25641rem;
                height: 10.25641rem;
              }

              .cit-label {
                margin-top: 1.2rem;
                color: #000;
                height: 5.89744rem;
                line-height: 5.89744rem;
                text-align: center;
                font-family: MHeiGB;
                font-size: 3.58974rem;
                font-style: normal;
                font-weight: 500;
              }
            }

          }
        }
      }
      .door{
        display: none;
      }

      .function {
        flex: 1;
        margin-left: 4rem;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .card-group {
        flex: 4;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

    }

    .outer-color-list {
      position: absolute;
      bottom: 24.4rem;
      height: 22rem;
      z-index: 4;
      padding: 0 3.9rem;
      width: 100vw;
      overflow: scroll;

      &::-webkit-scrollbar {
        display: none
      }

      .scroll {
        width: max-content;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .color-item {
        width: 26.92308rem;
        height: 22rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        position: relative;

        &:last-child {
          .line {
            display: none;
          }
        }

        .line {
          height: 12rem;
          width: 1px;
          background: #EAEAEA;
          position: absolute;
          right: 0px;
          top: 3rem;
          z-index: 4;
        }

        &.active {
          border-bottom: 1.02564rem solid #000;
        }

        .dot-box {
          width: 10.25641rem;
          height: 10.25641rem;
          margin-top: 2rem;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          position: relative;

          .dot {
            width: 10.25641rem;
            height: 10.25641rem;
            border-radius: 50%;
            overflow: hidden;
            display: flex;

            .hel {
              height: 100%;
              flex: 1;
            }
          }
        }

        .color-name {
          margin-top: 1.2rem;
          height: 5.89744rem;
          line-height: 5.89744rem;
          color: #000;

          text-align: center;
          font-family: MHeiGB;
          font-size: 3.58974rem;
          font-style: normal;
        }
      }
    }

    .inter-tool {
      position: absolute;
      z-index: 4;
      bottom: 1.8rem;
      left: 0;
      width: 100%;

      .card {
        height: 20.51282rem;
        padding: 1.54rem 4.35rem;
        position: relative;
        border-radius: 1.28205rem;
        background: rgba(0, 0, 0, 0.70);

        .card-item {
          margin-right: 3.6rem;

          .card-item-top {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: 14.35897rem;
            height: 17.4359rem;
            border-radius: 1.28205rem;

            &.active {
              border-radius: 1.28205rem;
              background: #303030;
            }

            .icon {
              width: 7.69231rem;
              height: 7.69231rem;
              margin-bottom: 1.79rem;
            }

            .label {
              color: #FFF;
              text-align: center;
              font-family: MHeiGB;
              font-size: 3.58974rem;
              font-style: normal;
              font-weight: 500;
            }

            .btn {
              display: none;
            }
          }

          .card-item-content {
            height: 22rem;
            top: -24rem;
            width: max-content;
            border-radius: 1.28205rem;
            background: rgba(11, 11, 13, 0.70);

            display: flex;
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            align-items: center;
            justify-content: center;

            .card-content-item {
              display: flex;
              flex-direction: column;
              align-items: center;
              width: 30.76923rem;
              height: 22rem;
              position: relative;

              &:last-child {
                .line {
                  display: none;
                }
              }

              .line {
                height: 15.38462rem;
                width: 1px;
                background: #EAEAEA;
                position: absolute;
                right: 0px;
                top: 4.87rem;
                z-index: 4;
              }

              &.active {
                border-bottom: 1.02564rem solid #FFFFFF;
              }

              .cit-icon-box {
                width: 10.25641rem;
                height: 10.25641rem;
                margin-top: 1rem;
              }

              .cit-icon {
                width: 10.25641rem;
                height: 10.25641rem;
              }

              .cit-label {
                margin-top: 1.2rem;
                color: #fff;
                height: 5.89744rem;
                line-height: 5.89744rem;
                text-align: center;
                font-family: MHeiGB;
                font-size: 3.58974rem;
                font-style: normal;
                font-weight: 500;
              }
            }

          }
        }
      }

      .card-group {
        width: 100vw;
        float: left;
        display: flex;
        align-items: center;
        justify-content: center;
      }

    }

    .tool-box {

    }


    .icon-360 {
      width: 60px;
      height: 22px;
      background-image: url("static/img/360.png");
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 62rem;
      z-index: 8;

      &.bot {
        bottom: 34rem;
      }

    }

    .inter-color-list {
      position: absolute;
      bottom: 24.4rem;
      height: 22rem;
      z-index: 4;
      padding: 0 3.9rem;
      border-radius: 1.28205rem;
      background: rgba(11, 11, 13, 0.70);
      display: flex;
      align-items: center;
      justify-content: center;
      width: max-content;
      left: 50%;
      transform: translateX(-50%);

      .pos-group {
        display: none;
      }


      .color-item {
        width: 26.92308rem;
        height: 22rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        position: relative;

        &:last-child {
          .line {
            display: none;
          }
        }

        .line {
          height: 12rem;
          width: 1px;
          background: #EAEAEA;
          position: absolute;
          right: 0px;
          top: 3rem;
          z-index: 4;
        }

        &.active {
          border-bottom: 1.02564rem solid #FFFFFF;
        }

        .dot-box {
          width: 10.25641rem;
          height: 10.25641rem;
          margin-top: 2rem;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          position: relative;

          .dot {
            width: 10.25641rem;
            height: 10.25641rem;
            border-radius: 50%;
            overflow: hidden;
            display: flex;

            .hel {
              height: 100%;
              flex: 1;
            }
          }
        }

        .color-name {
          margin-top: 1.2rem;
          height: 5.89744rem;
          line-height: 5.89744rem;
          color: #FFFFFF;

          text-align: center;
          font-family: MHeiGB;
          font-size: 3.58974rem;
          font-style: normal;
        }
      }
    }
  }
}


</style>
